export default "__VITE_ASSET__f0a37159__"